import { twMerge } from 'tailwind-merge'
import { GTooltip } from '../g-tooltip'
import { GCheckboxProps } from './types'
import { AiOutlineQuestionCircle } from 'react-icons/ai'

export const GCheckbox = (props: GCheckboxProps) => {
	const {
		name,
		onChange,
		checked,
		label,
		description,
		disabled = false,
		helpText,
		className = '',
		checkboxClassName = '',
		labelClassName = ''
	} = props
	return (
		<div className={twMerge('relative flex items-start', className)}>
			<div className="flex items-center h-5 ">
				<input
					id={name}
					aria-describedby={`${name}-description`}
					name={name}
					type="checkbox"
					checked={checked}
					disabled={disabled}
					onChange={(e) => onChange(e)}
					className={twMerge(
						'rounded cursor-pointer h-4 w-4 text-white border-1 checked:border-t-dark-blue checked:bg-t-dark-blue checked:focus:border-t-dark-blue checked:hover:border-t-dark-blue checked:hover:bg-t-dark-blue checked:focus:bg-t-dark-blue border-t-radio focus:ring-offset-0 bg-transparent checked:focus:ring-0 !checked:focus:outline-0 focus:ring-0 focus:outline-none !focus:outline-0 !focus:outline-offset-0',
						disabled
							? 'checked:border-t-dark-blue opacity-50'
							: '',
						checkboxClassName
					)}
				/>
			</div>
			<div className="ml-3 text-base">
				{label && (
					<label
						htmlFor={name}
						className={twMerge(
							'text-md text-t-google-tooltip cursor-pointer',
							disabled && 'opacity-50',
							labelClassName
						)}
					>
						{label}
					</label>
				)}
				{description && (
					<p id={`${name}-description`} className="text-gray-500 text-sm">
						{description}
					</p>
				)}
			</div>
			{helpText && (
				<GTooltip
					position="top"
					arrowClassName="w-0 h-0 absolute bottom-[0.5px] border-l-8 border-l-transparent  border-r-8 border-r-transparent border-t-8 border-t-tooltip-caret"
					contentClassName="border-none font-grotesk mb-2 bg-t-smoke w-[300px] font-medium text-sm text-t-desc-gray"
					content={helpText}>
					<AiOutlineQuestionCircle className="ml-2 h-4 w-4 text-t-gray-hold" />
				</GTooltip>
			)}
		</div>
	)
}
